/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Dropdown, Table, Modal } from "react-bootstrap";
import { useCallback, useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { useTranslate } from "../hooks/LanguageProvider";
import { PropagateLoader } from "react-spinners";
import {
  DownloadModal,
  generateExcelFile,
  generatePDFFile,
  addHiddenColumn,
  removeHiddenColumn,
  getHiddenColumns,
} from "../utilities/functions";
import { Button } from "react-bootstrap";
import EditSupplierModal from "../components/Supplier/EditSupplierModal";
import DeleteSupplierModal from "../components/Supplier/DeleteSupplierModal";
const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface SupplierInterface {
  id_supplier: number;
  id_user: number;
  legal_name: string;
  trade_name: string;
  email: string;
  phone: string;
  rc_number: string;
  wilaya: string;
  website: string;
  workforce_total: number;
  industrial_status: string;
}

export function Suppliers() {
  const PAGE_ID = 6;
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const id_user = user?.id_user ?? 0;
  console.log("USER:", user);
  console.log("ID_USER:", id_user);
  const id_user_number = Number(user.id_user ?? 0);

  const { translate } = useTranslate();
  const [list_suppliers, setSuppliers] = useState<SupplierInterface[]>([]);
  const [pageCount, setPageCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [limitValue, setSelectedLimitValue] = useState(10);
  const [loading, setLoading] = useState(true);
  const [showCreateUserFirstModal, setShowCreateUserFirstModal] =
    useState(false);

  const [modalStatus, setModalStatus] = useState<string | null>(null);
  const [titleStatus, setTitleStatus] = useState<string | null>(null);
  const [IdUser, setIdUser] = useState<number>(0);
  const [IdSupplier, setIdSupplier] = useState<number>(0);

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [column, setSortColumn] = useState("legal_name");
  const [sort, setSort] = useState("ASC");

  const [search, setSearch] = useState("");
  const [type, setType] = useState(0);
  const [typeSearch, setTypeSearch] = useState("company_name");
  const [selectedSearch, setSelectedSearch] = useState(
    translate("company_name"),
  );
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedSupplier, setSelectedSupplier] =
    useState<SupplierInterface | null>(null);
  const [showDownloadModal, setShowDownloadModal] = useState(false);

  const [selectedColumns, setSelectedColumns] = useState({
    id_supplier: true,
    legal_name: true,
    email: true,
    phone: true,
    wilaya: true,
    industrial_status: true,
  });

  const [selectedSuppliers, setSelectedSuppliers] = useState<Set<number>>(
    new Set(),
  );

  const getStatusBadge = (status: string) => {
    const value = (status || "incomplete").toLowerCase();

    const config = {
      active: {
        label: translate("active"),
        bg: "linear-gradient(135deg, #ecfdf3 0%, #d1fae5 100%)",
        color: "#166534",
        border: "#86efac",
        dot: "#22c55e",
        shadow: "0 4px 14px rgba(34, 197, 94, 0.16)",
      },
      inactive: {
        label: translate("inactive"),
        bg: "linear-gradient(135deg, #fff1f2 0%, #ffe4e6 100%)",
        color: "#b91c1c",
        border: "#fda4af",
        dot: "#ef4444",
        shadow: "0 4px 14px rgba(239, 68, 68, 0.14)",
      },
      incomplete: {
        label: translate("incomplete"),
        bg: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",
        color: "#b45309",
        border: "#fcd34d",
        dot: "#f59e0b",
        shadow: "0 4px 14px rgba(245, 158, 11, 0.14)",
      },
    };

    const current = config[value as keyof typeof config] || config.incomplete;

    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          padding: "6px 14px",
          borderRadius: "999px",
          background: current.bg,
          color: current.color,
          border: `1px solid ${current.border}`,
          boxShadow: current.shadow,
          fontSize: "12px",
          fontWeight: 600,
        }}
      >
        <span
          style={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            background: current.dot,
          }}
        />
        {current.label}
      </span>
    );
  };

  const actionButtonStyle = {
    width: "38px",
    height: "38px",
    padding: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1,
  } as const;
  // ✅ Load hidden columns from DB
  useEffect(() => {
    (async () => {
      if (!id_user_number) return;
      try {
        const hidden = await getHiddenColumns(id_user_number, PAGE_ID);
        setSelectedColumns((prev: any) => {
          const next = { ...prev };
          hidden.forEach((key: string) => {
            if (key in next) next[key] = false;
          });
          return next;
        });
      } catch (e) {
        console.error(e);
      }
    })();
  }, [id_user_number, PAGE_ID]);

  const supplierHeaders = [
    "ID",
    "Company name",
    "Email",
    "Phone",
    "Wilaya",
    "Status",
  ];
  const downloadSupplierExcel = () => {
    const selectedData = list_suppliers.map((s) => [
      s.id_supplier,
      s.legal_name || s.trade_name || "-",
      s.email || "-",
      s.phone || "-",
      s.wilaya || "-",
      s.industrial_status,
    ]);

    generateExcelFile("Suppliers List", supplierHeaders, selectedData);
  };
  const onDownloadConfirm = (format: string) => {
    if (format === "excel") {
      downloadSupplierExcel();
    }

    if (format === "pdf") {
      generatePDFFile(
        "Suppliers List",
        supplierHeaders,
        list_suppliers.map((s) => [
          s.id_supplier,
          s.legal_name || s.trade_name || "-",
          s.email || "-",
          s.phone || "-",
          s.wilaya || "-",
          s.industrial_status,
        ]),
      );
    }
  };
  const handleTypeSearch = (event: any) => {
    const selectedValue = event.target.textContent;

    switch (selectedValue) {
      case translate("id"):
        setType(0);
        setTypeSearch("id");
        break;

      case translate("company_name"):
        setType(1);
        setTypeSearch("company_name");
        break;

      case translate("email"):
        setType(2);
        setTypeSearch("email");
        break;

      case translate("phone"):
        setType(3);
        setTypeSearch("phone");
        break;

      case translate("wilaya"):
        setType(4);
        setTypeSearch("wilaya");
        break;

      case translate("status"):
        setType(6);
        setTypeSearch("status");
        break;
    }

    setSelectedSearch(selectedValue);
  };

  const Options = ["id", "company_name", "email", "phone", "wilaya", "status"];

  const handleAdvancedSearch = async (event: any) => {
    const newValue = event.target.value;
    setSearch(newValue);
    await getSuppliers(limitValue, currentPage, newValue, type, column, sort);
  };

  // ✅ Toggle column + sync to DB (preferences)
  const handleColumnChange = async (colKey: string) => {
    if (!id_user_number) return;

    const currentlyVisible = !!(selectedColumns as any)[colKey];
    const nextVisible = !currentlyVisible;

    setSelectedColumns((prev: any) => ({ ...prev, [colKey]: nextVisible }));

    try {
      if (!nextVisible) {
        await addHiddenColumn({
          id_user: id_user_number,
          id_page: PAGE_ID,
          column_name: colKey,
        });
      } else {
        await removeHiddenColumn({
          id_user: id_user_number,
          id_page: PAGE_ID,
          column_name: colKey,
        });
      }
    } catch (e) {
      console.error(e);
      setSelectedColumns((prev: any) => ({
        ...prev,
        [colKey]: currentlyVisible,
      }));
    }
  };

  const handleSortingColum = (currentColumn: string) => {
    const nextSort = sort === "DESC" ? "ASC" : "DESC";
    setSort(nextSort);
    setSortColumn(currentColumn);
    setCurrentPage(1);
    getSuppliers(limitValue, 1, search, type, currentColumn, nextSort);
  };

  const handleDeleteSupplier = async (id_supplier: string, IdUser: number) => {
    try {
      setModalStatus(translate("delete_supplier_confirm"));
      setTitleStatus(translate("delete_supplier"));
      setIdUser(IdUser);
      setIdSupplier(parseInt(id_supplier));
    } catch (error) {
      console.error(error);
    }
  };

  const closeModal = () => {
    setModalStatus(null);
  };
  /*********/
  const handleGoToAddSupplierUser = () => {
    setShowCreateUserFirstModal(false);
    navigate("/User?role=supplier");
  };

  const handleCloseCreateUserFirstModal = () => {
    setShowCreateUserFirstModal(false);
  };
  const handleOpenSupplierProfile = (supplier: SupplierInterface) => {
    const targetUserId = supplier?.id_user;

    if (
      targetUserId === null ||
      targetUserId === undefined ||
      String(targetUserId) === "null" ||
      String(targetUserId) === "undefined" ||
      String(targetUserId).trim() === ""
    ) {
      console.error("Supplier is missing id_user:", supplier);
      alert(
        "This supplier is not linked to a user account yet. Please check the supplier record in the database.",
      );
      return;
    }

    navigate(`/profileSupplier/${targetUserId}`, {
      state: { canEditCompany: true },
    });
  };
  const handleSelectChange = async (event: any) => {
    const newValue = event.target.value;
    setCurrentPage(1);
    setSelectedLimitValue(newValue);

    const suppliersFromServer = await getSuppliers(
      parseInt(newValue),
      1,
      search,
      type,
      column,
      sort,
    );
    setSuppliers(suppliersFromServer);
    window.scrollTo(0, 0);
  };

  const getSuppliers = useCallback(
    async (
      limitValue: number,
      currentPage: number,
      search: string,
      type: number,
      column: string,
      sort: string,
    ) => {
      // ✅ ADD THIS RIGHT HERE
      console.log("BODY SENT:", {
        limitValue,
        currentPage,
        search,
        type,
        id_user,
        column,
        sort,
      });
      const bodyData = JSON.stringify({
        limitValue,
        currentPage,
        search,
        type,
        id_user,
        column,
        sort,
      });

      try {
        setLoading(true);
        const total_pages = await fetch(
          `${backendUrl}/api/suppliers/search/totalpage`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: bodyData,
          },
        );

        const totalPages = await total_pages.json();

        console.log("TOTAL PAGE RESPONSE:", totalPages);

        const t = totalPages?.total || 0;

        setTotal(t);

        const supplierResponse = await fetch(
          `${backendUrl}/api/suppliers/search`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: bodyData,
            mode: "cors",
          },
        );

        if (!supplierResponse.ok) {
          console.error("Error retrieving suppliers list");
          setLoading(false);
          return;
        }

        const data = await supplierResponse.json();
        setPageCount(Math.ceil(t / limitValue));
        setSuppliers(data);
        return data;
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
    [id_user],
  );

  useEffect(() => {
    getSuppliers(limitValue, currentPage, search, type, column, sort);
  }, [column, currentPage, getSuppliers, limitValue, search, sort, type]);

  const updateSupplierList = async () => {
    await getSuppliers(limitValue, currentPage, search, type, column, sort);
  };

  const handlePageClick = async (data: any) => {
    const nextPage = data.selected + 1;
    await getSuppliers(limitValue, nextPage, search, type, column, sort);
    setCurrentPage(nextPage);
    window.scrollTo(0, 0);
  };

  const handleSelectAll = (e: any) => {
    e.stopPropagation();
    if (e.target.checked) {
      const allIds = new Set(list_suppliers.map((s) => s.id_supplier));
      setSelectedSuppliers(allIds);
    } else {
      setSelectedSuppliers(new Set());
    }
  };

  const handleSelectSupplier = (e: any, id_supplier: number) => {
    e.stopPropagation();
    const newSelected = new Set(selectedSuppliers);
    if (newSelected.has(id_supplier)) {
      newSelected.delete(id_supplier);
    } else {
      newSelected.add(id_supplier);
    }
    setSelectedSuppliers(newSelected);
  };

  const isAllSelected =
    list_suppliers.length > 0 &&
    selectedSuppliers.size === list_suppliers.length;
  const isSomeSelected =
    selectedSuppliers.size > 0 &&
    selectedSuppliers.size < list_suppliers.length;

  // Reset selection when suppliers list changes
  useEffect(() => {
    setSelectedSuppliers(new Set());
  }, [currentPage, list_suppliers]);

  useEffect(() => {
    if (modalStatus === "success") {
      const timeoutId = setTimeout(() => {
        setModalStatus(null);
      }, 3000);

      return () => clearTimeout(timeoutId);
    }
  }, [modalStatus]);

  return (
    <div className="container-fluid">
      <div className="row mb-3">
        <div className="col-md-6">
          <h4 className="mb-0">
            <i className="las la-box me-2"></i>
            {translate("suppliers")} ({total})
          </h4>
        </div>

        <div className="col-md-6 text-end">
          <Dropdown className="d-inline me-2">
            <Dropdown.Toggle variant="warning">
              {translate("export")}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                onClick={() => {
                  onDownloadConfirm("excel");
                  setShowDownloadModal(false);
                }}
              >
                {translate("excel")}
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  onDownloadConfirm("pdf");
                  setShowDownloadModal(false);
                }}
              >
                {translate("pdf")}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <button
            className="btn btn-warning"
            onClick={() => setShowCreateUserFirstModal(true)}
          >
            + {translate("new_supplier")}
          </button>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-md-4">
          <div className="input-group">
            <Dropdown>
              <Dropdown.Toggle variant="link">
                <i className="fas fa-chevron-down"></i>
              </Dropdown.Toggle>

              <Dropdown.Menu onClick={handleTypeSearch}>
                {Options.map((option) => (
                  <Dropdown.Item key={option}>
                    {translate(option)}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            <input
              type="text"
              className="form-control"
              placeholder={`${translate("search_by")} ${translate(typeSearch)}`}
              value={search}
              onChange={handleAdvancedSearch}
            />

            <Button
              variant="secondary"
              style={{ height: "38px" }}
              onClick={() => setSearch("")}
            >
              ✕
            </Button>
          </div>
        </div>

        <div className="col-md-8 d-flex justify-content-end align-items-center">
          <div className="dataTables_length" id="DataTables_Table_0_length">
            <label style={{ marginBottom: "0" }}>
              {translate("Show")}
              <select
                name="DataTables_Table_0_length"
                aria-controls="DataTables_Table_0"
                className="custom-select custom-select-sm form-control form-control-sm ml-2"
                style={{ width: "66px" }}
                onChange={handleSelectChange}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="500">500</option>
              </select>
            </label>
          </div>

          <Dropdown>
            <Dropdown.Toggle
              variant=""
              id="dropdown-basic"
              title={translate("Display columns")}
            >
              <i className="las la-eye"></i>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item as="button">
                <input
                  type="checkbox"
                  checked={selectedColumns.id_supplier}
                  onChange={() => handleColumnChange("id_supplier")}
                />
                <span>{translate("id")}</span>
              </Dropdown.Item>

              <Dropdown.Item as="button">
                <input
                  type="checkbox"
                  checked={selectedColumns.legal_name}
                  onChange={() => handleColumnChange("legal_name")}
                />
                <span>{translate("company_name")}</span>
              </Dropdown.Item>

              <Dropdown.Item as="button">
                <input
                  type="checkbox"
                  checked={selectedColumns.email}
                  onChange={() => handleColumnChange("email")}
                />
                <span>{translate("email")}</span>
              </Dropdown.Item>

              <Dropdown.Item as="button">
                <input
                  type="checkbox"
                  checked={selectedColumns.phone}
                  onChange={() => handleColumnChange("phone")}
                />
                <span>{translate("phone")}</span>
              </Dropdown.Item>

              <Dropdown.Item as="button">
                <input
                  type="checkbox"
                  checked={selectedColumns.wilaya}
                  onChange={() => handleColumnChange("wilaya")}
                />
                <span>{translate("wilaya")}</span>
              </Dropdown.Item>

              <Dropdown.Item as="button">
                <input
                  type="checkbox"
                  checked={selectedColumns.industrial_status}
                  onChange={() => handleColumnChange("industrial_status")}
                />
                <span>{translate("status")}</span>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <Table className="dataTable role-table mt-3">
        <thead>
          <tr className="ligth ligth-data">
            <th style={{ width: "5%" }}>
              <div className="checkbox d-inline-block">
                <input
                  type="checkbox"
                  className="checkbox-input"
                  checked={isAllSelected}
                  ref={(el) => {
                    if (el) el.indeterminate = isSomeSelected;
                  }}
                  onChange={handleSelectAll}
                />
              </div>
            </th>

            {selectedColumns.id_supplier && (
              <th
                className="sorting"
                onClick={() => handleSortingColum("id_supplier")}
              >
                {translate("id")}
              </th>
            )}

            {selectedColumns.legal_name && (
              <th
                className="sorting"
                onClick={() => handleSortingColum("legal_name")}
              >
                {translate("company_name")}
              </th>
            )}

            {selectedColumns.email && <th>{translate("email")}</th>}

            {selectedColumns.phone && <th>{translate("phone")}</th>}

            {selectedColumns.wilaya && (
              <th
                className="sorting"
                onClick={() => handleSortingColum("wilaya")}
              >
                {translate("wilaya")}
              </th>
            )}

            {selectedColumns.industrial_status && (
              <th>{translate("status")}</th>
            )}

            <th>{translate("actions")}</th>
          </tr>
        </thead>

        <tbody className="ligth-body">
          {loading ? (
            <tr>
              <td className="text-center" colSpan={8}>
                <PropagateLoader size={15} />
              </td>
            </tr>
          ) : list_suppliers.length > 0 ? (
            list_suppliers.map((supplier) => {
              const companyName =
                supplier.legal_name || supplier.trade_name || "-";

              return (
                <tr key={supplier.id_supplier}>
                  <td>
                    <div className="checkbox d-inline-block">
                      <input
                        type="checkbox"
                        className="checkbox-input"
                        checked={selectedSuppliers.has(supplier.id_supplier)}
                        onChange={(e) =>
                          handleSelectSupplier(e, supplier.id_supplier)
                        }
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                  </td>

                  {selectedColumns.id_supplier && (
                    <td>{supplier.id_supplier}</td>
                  )}

                  {selectedColumns.legal_name && <td>{companyName}</td>}

                  {selectedColumns.email && <td>{supplier.email || "-"}</td>}

                  {selectedColumns.phone && <td>{supplier.phone || "-"}</td>}

                  {selectedColumns.wilaya && <td>{supplier.wilaya || "-"}</td>}

                  {selectedColumns.industrial_status && (
                    <td>{getStatusBadge(supplier.industrial_status)}</td>
                  )}

                  <td className="text-center">
                    <button
                      className="btn btn-sm me-2 rounded-circle"
                      style={{
                        ...actionButtonStyle,
                        backgroundColor: "#020815",
                        border: "1px solid #020815",
                        color: "#ffffff",
                      }}
                      title={translate("go_to_profile")}
                      onClick={() => handleOpenSupplierProfile(supplier)}
                    >
                      <i className="fas fa-user"></i>
                    </button>

                    <button
                      className="btn btn-sm btn-warning me-2 rounded-circle"
                      style={actionButtonStyle}
                      title={translate("edit")}
                      onClick={() => {
                        setSelectedSupplier(supplier);
                        setShowEditModal(true);
                      }}
                    >
                      <i className="fas fa-edit"></i>
                    </button>

                    <button
                      className="btn btn-sm btn-danger rounded-circle"
                      style={actionButtonStyle}
                      title={translate("delete")}
                      onClick={() =>
                        handleDeleteSupplier(
                          supplier.id_supplier.toString(),
                          parseInt(id_user ?? "0", 10),
                        )
                      }
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={8}>{translate("no_suppliers")}</td>
            </tr>
          )}
        </tbody>
      </Table>
      <div className="d-flex justify-content-between mt-3">
        <span>
          {translate("displaying")} {list_suppliers.length}{" "}
          {translate("out_of")} {total}
        </span>

        <div>
          <ReactPaginate
            previousLabel={translate("previous")}
            nextLabel={translate("next")}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={"pagination justify-content-end"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            activeClassName={"active"}
            forcePage={currentPage - 1}
          />
        </div>
        <EditSupplierModal
          show={showEditModal}
          onHide={() => {
            setShowEditModal(false);
            setSelectedSupplier(null);
          }}
          supplier={selectedSupplier}
          onSuccess={updateSupplierList}
        />
        <DeleteSupplierModal
          show={modalStatus !== null}
          onHide={closeModal}
          status={modalStatus}
          title={titleStatus}
          IdUser={IdUser}
          IdSupplier={IdSupplier}
          updateSupplierList={updateSupplierList}
        />
        <Modal
          show={showCreateUserFirstModal}
          onHide={handleCloseCreateUserFirstModal}
          centered
          backdrop="static"
        >
          <div
            style={{
              background: "#ffffff",
              border: "none",
              borderRadius: "18px",
              overflow: "hidden",
              boxShadow: "0 24px 60px rgba(15, 23, 42, 0.18)",
            }}
          >
            <Modal.Header
              closeButton
              style={{
                borderBottom: "1px solid #eef2f7",
                padding: "28px 32px 20px 32px",
                background: "#ffffff",
              }}
            >
              <div className="d-flex align-items-start gap-3 w-100">
                <div
                  style={{
                    width: "52px",
                    height: "52px",
                    borderRadius: "14px",
                    background:
                      "linear-gradient(135deg, #fff7d6 0%, #ffe58f 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    boxShadow: "0 8px 20px rgba(245, 158, 11, 0.18)",
                  }}
                >
                  <i
                    className="las la-user-plus"
                    style={{
                      fontSize: "26px",
                      color: "#a16207",
                    }}
                  />
                </div>

                <div>
                  <Modal.Title
                    style={{
                      margin: 0,
                      fontSize: "22px", // bigger
                      fontWeight: 700,
                      color: "#0f172a",
                      lineHeight: 1.2,
                      letterSpacing: "-0.4px",
                    }}
                  >
                    {translate("new_supplier_title")}
                  </Modal.Title>
                  <div
                    style={{
                      marginTop: "10px",
                      fontSize: "16px",
                      color: "#64748b",
                      fontWeight: 400,
                    }}
                  >
                    {translate("create_supplier_description")}
                  </div>
                </div>
              </div>
            </Modal.Header>

            <Modal.Footer
              style={{
                borderTop: "1px solid #eef2f7",
                padding: "20px 32px 24px 32px",
                background: "#ffffff",
                justifyContent: "center",
                gap: "12px",
              }}
            >
              <Button
                variant="light"
                onClick={handleCloseCreateUserFirstModal}
                style={{
                  minWidth: "140px",
                  height: "48px",
                  borderRadius: "10px",
                  border: "1px solid #d0d7e2",
                  color: "#475569",
                  fontWeight: 600,
                  background: "#ffffff",
                }}
              >
                {translate("cancel")}
              </Button>

              <Button
                onClick={handleGoToAddSupplierUser}
                style={{
                  minWidth: "180px",
                  height: "48px",
                  borderRadius: "10px",
                  border: "none",
                  fontWeight: 700,
                  background:
                    "linear-gradient(135deg, #facc15 0%, #f59e0b 100%)",
                  color: "#111827",
                  boxShadow: "0 10px 24px rgba(245, 158, 11, 0.22)",
                }}
              >
                <i className="las la-plus-circle me-2" />
                {translate("add_new_user")}
              </Button>
            </Modal.Footer>
          </div>
        </Modal>
        <DownloadModal
          show={showDownloadModal}
          onHide={() => setShowDownloadModal(false)}
          onDownloadConfirm={onDownloadConfirm}
        />
      </div>
    </div>
  );
}
